import React from 'react';
import i18next from 'i18next';
import ESportsMenu from '../EsportsGame/ESportsMenu/ESportsMenu';
import { Route, Switch } from 'react-router-dom';
import Icon from '../Icon/Icon';
import mybetsIcon from 'icons/mybets.svg';
import { connect } from 'react-redux';
import { ModalsConsumer } from '../Modal/ModalsProvider';
import { setNewBetsFlag } from '../../actions/appActions';

import SpotlightList from '../EsportsGame/Spotlight/Spotlight';
import Delayed from '../Delayed/Delayed';
import MediaQuery from 'react-responsive';
import Wallet from '../Wallet/Wallet';

class RightSidebar extends React.PureComponent {
  renderMyBets() {
    const { newBets, setNewBetsFlag, route } = this.props;
    const formProps = {
      defaultTab:
        route === '/esports' || route.startsWith('/esports/') ? 'bets' : 'orders',
    };

    return (
      this.props.signedIn && (
        <ModalsConsumer>
          {({ showModal }) => (
            <div
              className="right-sidebar__item"
              onClick={() => {
                showModal(
                  <Wallet activeForm="history" formProps={formProps} />,
                  { position: 'top' }
                );
                setNewBetsFlag(false);
              }}
            >
              <div className="right-sidebar__item-logo text-icon text-icon--multiple">
                <span className="text-icon__icon right-sidebar__my-bets">
                  <Icon glyph={mybetsIcon} />
                  {newBets && <span className="right-sidebar__my-bets" />}
                </span>
              </div>
              <span className="right-sidebar__item-title">
                {i18next.t('my_bets_button')}
              </span>
            </div>
          )}
        </ModalsConsumer>
      )
    );
  }

  render() {
    return (
      <Switch>
        {['/esports', '/esports/:eventId'].map((path) => (
          <Route exact path={path} key={path}>
            <div className="right-sidebar">
              {this.renderMyBets()}
              <ESportsMenu />
            </div>
          </Route>
        ))}

        <Route path="/">
          <MediaQuery query="(min-width: 1100px)">
            <div className="right-sidebar">
              {this.renderMyBets()}
              <Delayed waitBeforeShow={1000}>
                <SpotlightList />
              </Delayed>
            </div>
          </MediaQuery>
        </Route>
      </Switch>
    );
  }
}

export default connect(
  (state) => {
    return {
      newBets: state.app.newBets,
      route: state.router.location.pathname,
      signedIn: !!state.user.profile,
    };
  },
  {
    setNewBetsFlag,
  }
)(RightSidebar);



// WEBPACK FOOTER //
// ./app/components/RightSidebar/RightSidebar.jsx